import React from 'react'

const DisplayTextDetail = ({settings, handleSettingsChanges}) => {

    return (
        <>
            <div className="field-group-container">
                <div className="field-container mt-2 mb-2">
                    <div className="justify-start flex">
                        <input
                            type="checkbox"
                            className="h-6 w-6 mr-1"
                            id="noText"
                            name="noText"
                            value={settings?.noText}
                            checked={settings?.noText}
                            onChange={handleSettingsChanges}>
                        </input>
                        <div className=''>
                            <label className='field-label self-center'
                                   htmlFor='noText'>No Text Design</label>
                        </div>
                    </div>
                </div>

                {!settings?.noText &&
                    <div className="field-container w-full -mt-2">
                        <div className="field-label">Display Text</div>
                        <textarea
                            id="displayText"
                            name="displayText"
                            disabled={settings?.noText}
                            value={settings?.displayText}
                            onChange={handleSettingsChanges}
                            className="text-area-field h-28"/>
                    </div>
                }
            </div>
        </>
    )
}

export default DisplayTextDetail
